import Vue from "vue";
//模块功能：产品详情-全球海洋气象水文预报
export default Vue.extend({
    name: "meteo-service",
    data: function () {
        return {
            contList1: {
                list1: ['风 / 阵风 / 气温 / 湿度 / 水温', '气压 / 能见度 / 云盖 / 降水', '耦合浪 / 风浪 / 涌浪 / 表层海流 / 潮汐', '台风 / 风暴潮等', '卫星云图 / 雷达图等'],
                list2: ['等值线', '热力图', '流线图'],
                list3: ['全球高分辨率大气数值模式预报（0.25°）', ' 全球海浪数值预报系统（0.08°）', '亚太高分辨率大气数值模式预报（9km）', '中国沿海高分辨率海浪、风暴潮数值预报系统']
            }
        };
    },
    mounted: function () {
    },
    methods: {},
    computed: {
        contents: function () {
            return this.$t('productsdetail.meteo');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/product/meteo-service.vue
// module id = null
// module chunks = 